module.exports = __webpack_public_path__ + "static/media/arvr.73a42ddc.png";